module.exports = __webpack_public_path__ + "img/serial.075cff98.svg";